// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 13) return "static/js/85b36c51f102f5206006.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"372ff70b629f2433d639","139":"1cfb719ef9093f3e6f3a","140":"e0ee8a845f4a398e82bb"}[chunkId] + ".chunk.js";
};